(function(){
  "use strict";
  if(window.__oraInit) return; window.__oraInit = true;
  var root = document;
  var IMGS = window.ORA_IMGS || {}, VARIANTS = window.ORA_VARIANTS || [];

  var hv = root.querySelector('.hero-video');
  if(hv && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ hv.removeAttribute('autoplay'); try{hv.pause();}catch(e){} }

  var nav = root.querySelector('#nav');
  var anno = root.querySelector('.anno-bar');
  var pageWrap = root.querySelector('.page-wrapper');
  var navH = nav ? nav.offsetHeight : 74;
  /* On Horizon the desktop scroll container is .page-wrapper (html/body are
     overflow:hidden at >=990px); on mobile the window scrolls. Only one is ever
     non-zero, so max() returns whichever is the live scroller — no need to
     re-detect on resize. */
  function scrollTop(){
    var w = window.scrollY || document.documentElement.scrollTop || 0;
    var p = pageWrap ? pageWrap.scrollTop : 0;
    return w > p ? w : p;
  }
  var lastY = scrollTop();
  /* hitcrave-style header: at the very top the nav tucks under the announcement
     bar; once you scroll past it the nav HIDES on scroll-down and slides back in
     + pins to the top on scroll-up. */
  function navState(){
    if(!nav) return;
    var y = scrollTop();
    var annoH = anno ? anno.offsetHeight : 0;
    navH = nav.offsetHeight || navH;
    nav.classList.toggle('scrolled', y > 24);
    if(y <= annoH){
      nav.classList.add('no-anim');
      nav.classList.remove('nav-hidden');
      nav.style.transform = 'translateY(' + (annoH - y) + 'px)';
      lastY = y; return;
    }
    nav.classList.remove('no-anim');
    nav.style.transform = '';
    var dy = y - lastY;
    if(Math.abs(dy) < 4) return;
    if(dy > 0 && y > annoH + navH){ nav.classList.add('nav-hidden'); }
    else if(dy < 0){ nav.classList.remove('nav-hidden'); }
    lastY = y;
  }
  navState();
  window.addEventListener('scroll', navState, {passive:true});
  if(pageWrap) pageWrap.addEventListener('scroll', navState, {passive:true});
  document.addEventListener('scroll', navState, {passive:true, capture:true});
  window.addEventListener('resize', navState);

  var burger = root.querySelector('#hamburger'), links = root.querySelector('#navLinks');
  if(burger && links){
    burger.addEventListener('click', function(){ var o = links.classList.toggle('open'); burger.setAttribute('aria-expanded', o); });
    links.addEventListener('click', function(e){ if(e.target.tagName==='A'){ links.classList.remove('open'); burger.setAttribute('aria-expanded','false'); }});
  }

  var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }}); }, {threshold:0.18});
  function observeReveals(scope){ (scope||root).querySelectorAll('.reveal, .step').forEach(function(el){ io.observe(el); }); }
  observeReveals(root);
  /* Theme editor: a re-rendered section's fresh .reveal/.step elements aren't
     tracked by the original observer, so they would stay invisible (the section
     looks blank). Reveal them immediately whenever a section (re)loads. */
  document.addEventListener('shopify:section:load', function(e){ var sc=e.target||root; sc.querySelectorAll('.reveal, .step').forEach(function(el){ el.classList.add('in'); }); });

  /* exploded-view scroll story */
/* ===== exploded-view scroll story ===== */
  (function(){
    var track=document.getElementById('exTrack');
    if(!track) return;
    // Respect reduced-motion: leave parts in their CSS static exploded layout, no scroll binding.
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var caption=document.getElementById('exCaption');
    var dotsWrap=document.getElementById('exDots');
    var hint=document.getElementById('exHint');
    var floor=document.getElementById('floor');

    var parts=[
      {id:'p-body',    off: 96, label:null,        start:0.00,end:0.46},
      {id:'p-oring',   off: 34, label:null,        start:0.05,end:0.44},
      {id:'p-housing', off:  6, label:'l-housing', start:0.09,end:0.50},
      {id:'p-pcb',     off:-20, label:'l-pcb',     start:0.13,end:0.54},
      {id:'p-speaker', off:-40, label:'l-speaker', start:0.17,end:0.58},
      {id:'p-screws',  off:-54, label:null,        start:0.19,end:0.56},
      {id:'p-plate',   off:-66, label:'l-plate',   start:0.22,end:0.62},
      {id:'p-lid',     off:-86, label:'l-lid',     start:0.26,end:0.66}
    ];
    var captions=[
      [0,'Scroll to take it apart.'],
      [0.32,'A speaker, a mount, and 24-hour insulation — engineered into one lid.'],
      [0.66,'Eight parts. One seamless bottle.'],
      [0.82,'Scroll up to put it back together.']
    ];
    var els={}; parts.forEach(function(pt){ els[pt.id]=document.getElementById(pt.id); if(pt.label) els[pt.label]=document.getElementById(pt.label); });
    parts.forEach(function(){ dotsWrap.appendChild(document.createElement('i')); });
    var dotEls=dotsWrap.querySelectorAll('i');

    function ease(t){ return t<0.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2; }
    function clamp(v){ return v<0?0:v>1?1:v; }
    var ticking=false,lastP=-1;
    function update(){
      ticking=false;
      var r=track.getBoundingClientRect();
      var total=track.offsetHeight-window.innerHeight;
      var p=clamp(-r.top/total);
      if(Math.abs(p-lastP)<0.0008) return;
      lastP=p;
      parts.forEach(function(pt,idx){
        var local=clamp((p-pt.start)/(pt.end-pt.start));
        var e=ease(local);
        if(els[pt.id]) els[pt.id].style.transform='translateY('+(pt.off*e)+'px)';
        if(pt.label&&els[pt.label]) els[pt.label].style.opacity=(e>0.5&&p<0.74)?'1':'0';
        dotEls[idx].classList.toggle('on',e>0.15);
      });
      if(floor) floor.style.opacity=(1-0.5*clamp(p/0.5));
      if(hint) hint.style.opacity=p>0.04?'0':'1';
      var cap=captions[0][1];
      for(var i=0;i<captions.length;i++){ if(p>=captions[i][0]) cap=captions[i][1]; }
      if(caption.textContent!==cap) caption.textContent=cap;
    }
    window.addEventListener('scroll',function(){ if(!ticking){requestAnimationFrame(update);ticking=true;} },{passive:true});
    window.addEventListener('resize',update);
    update();
  })();

  var orderBottle = root.querySelector('#orderBottle');
  var colorName = root.querySelector('#colorName');
  var swatches = root.querySelectorAll('.swatch');
  var variantInput = root.querySelector('#variantId');
  var priceVal = root.querySelector('#priceVal');
  var addBtn = root.querySelector('#addCart');
  var selFinish = 'Onyx';

  function findVariant(f){ for(var i=0;i<VARIANTS.length;i++){ if(VARIANTS[i].finish===f) return VARIANTS[i]; } return null; }
  function syncVariant(){
    var v = findVariant(selFinish); if(!v) return;
    if(variantInput) variantInput.value = v.id;
    if(priceVal) priceVal.textContent = v.price;
    if(addBtn){ if(v.available===false){ addBtn.textContent='Sold out'; addBtn.disabled=true; } else if(addBtn.disabled){ addBtn.textContent='Add to cart'; addBtn.disabled=false; } }
  }
  function setFinish(key, name){
    selFinish = name;
    swatches.forEach(function(s){ s.setAttribute('aria-pressed', s.dataset.name===name ? 'true':'false'); });
    if(colorName) colorName.textContent = name;
    var src = (window.ORA_FINISH_IMGS && window.ORA_FINISH_IMGS[key]) || IMGS[key];
    if(orderBottle && src){ orderBottle.style.opacity='0'; var pre=new Image(); pre.onload=function(){ orderBottle.src=src; orderBottle.alt='ora Max in '+name; orderBottle.style.opacity='1'; }; pre.src=src; }
    syncVariant();
  }
  swatches.forEach(function(sw){ sw.addEventListener('click', function(){ setFinish(sw.dataset.img, sw.dataset.name); }); });
  (function(){ var init=null; swatches.forEach(function(s){ if(!init && s.getAttribute('aria-pressed')==='true') init=s; }); if(!init && swatches[0]) init=swatches[0]; if(init){ setFinish(init.dataset.img, init.dataset.name); } else { syncVariant(); } })();

  root.querySelectorAll('.faq-item').forEach(function(item){
    var q=item.querySelector('.faq-q'), a=item.querySelector('.faq-a');
    q.addEventListener('click', function(){ var open=item.classList.toggle('open'); a.style.maxHeight = open ? a.scrollHeight+'px' : '0'; });
  });
})();